import {DvDocument} from '@dv5/domain'

export const getAvailableDocuments = (documents: Array<DvDocument>, currentDocumentId: string): Array<DvDocument> => {
    return documents.filter(document => document.id !== currentDocumentId)
}

export const validateDocumentSelection = (selectedDocumentId: string, currentDocumentId: string): string | null => {
    if (!selectedDocumentId) {
        return 'Please select a document'
    }
    if (selectedDocumentId === currentDocumentId) {
        return 'Select a different document'
    }
    return null
}